import { TOKEN_TYPES } from '../bill/lib';

export const splTokensConfig = {
  [TOKEN_TYPES.USDC]: {
    splAddress: 'EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v',
    decimals: 6,
  },
};
